/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「文字输入框=>无空格」
 * @modify Date:2021.2.17 15:22
 */
<template>
  <div class="cTextInput-container">
    <input
      type="text"
      autocapitalize="off"
      autocorrect="off"
      :maxlength="maxlength ? maxlength : '200'"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="newValue"
      :class="{ error: formatError, inputEdited: newValue }"
      @blur="handleblur"
      @focus="handleComposing"
      @input="handleInput"
      v-disable-emoji-input
    />
    <!--      oninput="value=value.replace(/\u0020/g, '').replace(/\u3000/g, '')"-->
    <p v-if="formatError" class="inputMessage" v-html="$sanitize(message)"></p>
  </div>
</template>

<script>
export default {
  name: 'InputItemNotSpace',
  props: [
    'value',
    'placeholder', //提示信息
    'message', //错误信息
    'formatError',
    'disabled',
    'onkeypress',
    'maxlength'
  ],
  data() {
    return {
      newValue:''
    };
  },
  watch:{
    value(newV){
      this.newValue=newV
    }
  },
  created() {
    this.newValue=this.value
  },
  methods: {
    //正在输入
    handleComposing() {
      this.$emit('update:formatError', false);
    },
    // 失去焦点，校验信息ださい
    handleblur() {
      this.$emit('blur');
    },
    handleInput($event){
      let value=$event.target.value;
      let valueArr=value.split('').filter((s)=>{return s && s.trim()})
      this.newValue=valueArr.join('')
      this.$emit('input', valueArr.join(''))
    }
  }
};
</script>
<style scoped lang="less">
.cTextInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  height: 0.55rem;
  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }
  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }
  .error {
    border: 1px solid red;
  }
  .inputMessage {
    position: absolute;
    top: 0.5rem;
    padding: 0 0.05rem;
    color: red;
    font-size: 0.12rem;
    line-height: 0.14rem;
    min-height: 0.28rem;
    white-space: pre-wrap;
    margin-top: 0.05rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cTextInputNotSpace.vue